import React from "react";

export default function Title() {
  return (
    <div className="title">
      <h1 className="title__h1">ONLINE SHOPPING EXPERIENCE</h1>
    </div>
  );
}
